import React from "react";
import styled from "@emotion/styled";
import {useSelector} from "react-redux";
import {
	getActiveContestCategory,
	getActiveContestTranslationCategory,
	getCurrentQuestion,
} from "modules/selectors/contest";
import {getPlayerById} from "modules/selectors";
import {useTranslation} from "react-i18next";

const QuestionText = styled.h2`
  position: relative;
  z-index: 22;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  color: ${({theme}) => theme.colors.text.white};
  max-width: 360px;
  width: 100%;
  margin-top: 18px;

  span {
    color: ${({theme}) => theme.colors.brand.primary};
  }
}
`;

export const Question: React.FC = () => {
	const {t} = useTranslation();
	const question = useSelector(getCurrentQuestion);
	const categoryText = t(useSelector(getActiveContestTranslationCategory));
	const category = useSelector(getActiveContestCategory);

	const translationKey = `game.gameplay.question.${category}`;

	const playerOne = useSelector(getPlayerById)(question?.playerIdOne);
	const playerTwo = useSelector(getPlayerById)(question?.playerIdTwo);

	const playerOneName = playerOne ? `${playerOne.firstName} ${playerOne.lastName}` : "-";
	const playerTwoName = playerTwo ? `${playerTwo.firstName} ${playerTwo.lastName}` : "-";

	if (!question) {
		return null;
	}

	return (
		<QuestionText
			dangerouslySetInnerHTML={{
				__html: t(translationKey, {
					P1: playerOneName,
					P2: playerTwoName,
					S: categoryText,
				}),
			}}
		/>
	);
};
